// @flow
import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateBank(bank: string): ?UserInputValidationError {
  if (!bank || bank.trim() === '')
    return { id: 'empty' };

  return VALID;
}
